mainApp.component('siteRecoveryPolicy',{
    templateUrl: '/public/components/site-recovery-policy.component.html',
    bindings: {
        hasAltWan: '=',
        siteBandwidth: '=',
        siteRecoveryPolicy: '=',
        siteId: '='
    },
    controller: siteRecoveryPolicyController
});

function siteRecoveryPolicyController($scope, $state, IconsService){
    var ctrl = this;
    $scope.recoveryMethodOptions = [
        {
            label: "Auto",
            id: "AUTO"
        },{
            label: "Specific Site",
            id: "SPECIFIC_SITE"
        }
    ];
    $scope.datamodified = false;

    $scope.enableRecoveryInternetChanged = function(){

        if (ctrl.siteRecoveryPolicy.enableRecoveryInternet){
            ctrl.siteRecoveryPolicy.enableAllInternetTraffic = (ctrl.siteRecoveryPolicy.enableAllInternetTraffic == null) ? ctrl.siteRecoveryPolicy.$enableAllInternetTraffic : ctrl.siteRecoveryPolicy.enableAllInternetTraffic;
            ctrl.siteRecoveryPolicy.internetPriority = (ctrl.siteRecoveryPolicy.internetPriority == null) ? ctrl.siteRecoveryPolicy.$internetPriority : ctrl.siteRecoveryPolicy.internetPriority;
            $scope.restoreRecoveryPolicyMethodDetails();
            if (ctrl.siteRecoveryPolicy.enableAllInternetTraffic == null)
                ctrl.siteRecoveryPolicy.enableAllInternetTraffic = true;
        }else{
            ctrl.siteRecoveryPolicy.$enableAllInternetTraffic = ctrl.siteRecoveryPolicy.enableAllInternetTraffic;
            ctrl.siteRecoveryPolicy.$internetPriority = ctrl.siteRecoveryPolicy.internetPriority;
            ctrl.siteRecoveryPolicy.enableAllInternetTraffic = undefined;
            ctrl.siteRecoveryPolicy.internetPriority = undefined;
            $scope.storeRecoveryPolicyMethodDetails();
        }
    }

    $scope.enableRecoveryWanChanged = function() {

        if (ctrl.siteRecoveryPolicy.enableRecoveryWan){
            ctrl.siteRecoveryPolicy.enableAllWanTraffic = (ctrl.siteRecoveryPolicy.enableAllWanTraffic == null) ? ctrl.siteRecoveryPolicy.$enableAllWanTraffic : ctrl.siteRecoveryPolicy.enableAllWanTraffic;
            ctrl.siteRecoveryPolicy.wanPriority = (ctrl.siteRecoveryPolicy.wanPriority == null) ? ctrl.siteRecoveryPolicy.$wanPriority : ctrl.siteRecoveryPolicy.wanPriority;
            $scope.restoreRecoveryPolicyMethodDetails();
            if (ctrl.siteRecoveryPolicy.enableAllWanTraffic == null)
               ctrl.siteRecoveryPolicy.enableAllWanTraffic = true;
        }else{
            ctrl.siteRecoveryPolicy.$enableAllWanTraffic = ctrl.siteRecoveryPolicy.enableAllWanTraffic;
            ctrl.siteRecoveryPolicy.$wanPriority = ctrl.siteRecoveryPolicy.wanPriority;
            ctrl.siteRecoveryPolicy.enableAllWanTraffic = undefined;
            ctrl.siteRecoveryPolicy.wanPriority = undefined;
            $scope.storeRecoveryPolicyMethodDetails();
        }
    }

    $scope.storeRecoveryPolicyMethodDetails = function(){
        if (ctrl.siteRecoveryPolicy.enableRecoveryWan == true || ctrl.siteRecoveryPolicy.enableRecoveryInternet == true){
            return;
        }

        ctrl.siteRecoveryPolicy.$recoveryList = ctrl.siteRecoveryPolicy.recoveryList;
        ctrl.siteRecoveryPolicy.$recoveryMethodType = ctrl.siteRecoveryPolicy.recoveryMethodType;
        ctrl.siteRecoveryPolicy.recoveryList = undefined;
        ctrl.siteRecoveryPolicy.recoveryMethodType = undefined;
    }

    $scope.restoreRecoveryPolicyMethodDetails = function(){
        if (ctrl.siteRecoveryPolicy.enableRecoveryWan == true || ctrl.siteRecoveryPolicy.enableRecoveryInternet == true){
            if (ctrl.siteRecoveryPolicy.$recoveryMethodType == "SPECIFIC_SITE"){
                ctrl.siteRecoveryPolicy.recoveryList = ctrl.siteRecoveryPolicy.$recoveryList;
                ctrl.siteRecoveryPolicy.recoveryMethodType = ctrl.siteRecoveryPolicy.$recoveryMethodType;
                ctrl.siteRecoveryPolicy.$recoveryList = undefined;
                ctrl.siteRecoveryPolicy.$recoveryMethodType = undefined;
            }
            if (ctrl.siteRecoveryPolicy.recoveryMethodType == null)
                ctrl.siteRecoveryPolicy.recoveryMethodType = "AUTO";

            return;
        }

        ctrl.siteRecoveryPolicy.recoveryList = ctrl.siteRecoveryPolicy.$recoveryList;
        ctrl.siteRecoveryPolicy.recoveryMethodType = ctrl.siteRecoveryPolicy.$recoveryMethodType;
        if (ctrl.siteRecoveryPolicy.recoveryMethodType == null)
            ctrl.siteRecoveryPolicy.recoveryMethodType = "AUTO";
    }

    $scope.$watch('$ctrl.siteId', function(oldValue, newValue){
        if (oldValue === newValue)
            return;
        $scope.datamodified = new Date().getTime();
    });

    $scope.$watch('$ctrl.siteBandwidth', function(){
        if (ctrl && ctrl.siteBandwidth){
            ctrl.bwManagement = [];
            var bw = Object.keys(ctrl.siteBandwidth)[0];
            ctrl.siteBandwidth[bw].forEach(function(item){
                ctrl.bwManagement.push({value: item.priority, label: "P" + item.name})
            });
        }
    });

    $scope.canChangeMethod = function(){
        if (ctrl.siteRecoveryPolicy == null)
            return false;

        if (ctrl.siteRecoveryPolicy.enableRecoveryWan == true || ctrl.siteRecoveryPolicy.enableRecoveryInternet == true)
            return ctrl.hasAltWan;

        return false;
    }

    // this is the configuration for the sites for the site recovery options
    $scope.tableConfig = {
        dataURL: function() {
            return '/getAllSites?accountId=' + $state.params.accountId + '&filterByConnectionTypeFamily=SOCKET&filterByAltWan=true';
        },
        parseData: function(data){
            return data.filter(function( obj ) {
                return obj.id !== ctrl.siteId;
            });
        },
        fields: [
            {"label": "Name", "path": "name", "template": "<span>{{item.name}}</span>"},
            {"label": "Type", "path": "siteType", "template": "<span>{{item.siteType | capitalize }}</span>"}
        ],
        actions: [],
        selectedItems: [],
        pageSize: 5,
        titleSearch: "Name",
        sortField: "name",
        searchField: "name",
        type: "Site",
        icons: IconsService.getIcons('policy'),
        siteRecoveryPolicyEntryListSelect: function(id, item){
            $scope.siteRecoveryPolicyEntryListSelect(id, item);
        }
    };

    $scope.siteRecoveryPolicyEntryListSelect = function(id,item){
        $scope.tableConfig.selectedItems = [];

        if (ctrl.siteRecoveryPolicy.recoveryList){
            ctrl.siteRecoveryPolicy.recoveryList.forEach(function (siteItem) {
                $scope.tableConfig.selectedItems.push(siteItem);
            });
        }

        $scope.$root.openPopup("selectSiteRecoveryPolicyDlg");
    };

    $scope.addSiteRecoveryPolicyItem = function (){
        if (!ctrl.siteRecoveryPolicy.recoveryList){
            ctrl.siteRecoveryPolicy.recoveryList = [];
        }else{
            ctrl.siteRecoveryPolicy.recoveryList.length = 0;
        }

        $scope.tableConfig.selectedItems.forEach(function (siteItem) {
            ctrl.siteRecoveryPolicy.recoveryList.push(siteItem);
        });

        $scope.tableConfig.selectedItems = [];
        $scope.$root.closePopup('selectSiteRecoveryPolicyDlg');
    };
};
